import React from 'react';
import { useTranslation } from "react-i18next";
import { X } from 'lucide-react';

const ResumeDetailModal = ({ resume, isOpen, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen || !resume) return null;

  const pdfUrl = resume.file_url || resume.resume_url;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/30 backdrop-blur-md flex items-center justify-center p-4">
      <div
        className="bg-white rounded-2xl max-w-5xl w-full h-[95vh] flex flex-col shadow-2xl animate-in fade-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-4 border-b border-gray-100 flex items-center justify-between bg-white/50 backdrop-blur-sm rounded-t-2xl">
          <h2 className="text-xl font-semibold text-gray-900 tracking-tight">
            {t('myDetails.modals.resumeDetail.title', { name: resume.name })}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-500 hover:text-gray-900 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 bg-gray-50/50 rounded-b-2xl overflow-hidden">
          {pdfUrl ? (
            <iframe
              src={`${pdfUrl}#toolbar=0`}
              className="w-full h-full"
              title={t('myDetails.modals.resumeDetail.title', { name: resume.name })}
            />
          ) : (
            <div className="h-full flex items-center justify-center">
              <p className="text-gray-500 font-medium">{t('myDetails.modals.resumeDetail.notAvailable')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeDetailModal;
